<template>
  <!-- 课程发布页 -->
  <div class="form-content-container" style="overflow: hidden">
    <Form
      class="form-container"
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      label-position="left"
    >
      <FormItem
        ref="FormItemTitle"
        class="form-item"
        prop="title"
        :rules="[
          { validator: validatetitle, trigger: 'change | blur' },
          { required: true, message: '课程名称为空', trigger: 'change | blur' },
        ]"
      >
        <div class="title titleRichEditor">
          <title-summary-editor
            v-if="titleFocus"
            bodyClass="chineseTitle"
            :id="'chineseTitle'"
            v-model.trim="formValidate.title"
            :initWithBold="true"
            initFontSize="36px"
            :minHeight="62"
            :placeholder="'请输入课程名称（5-50字）'"
            @changeValue="getTitle"
          ></title-summary-editor>
        </div>
        <div class="number">
          <span :class="titleWordCount > 50 ? 'fontColor' : ''">{{
            titleWordCount
          }}</span>
          / 50
        </div>
      </FormItem>
      <FormItem class="form-item" label="封面" prop="cover">
        <div class="demo-upload-list" v-if="formValidate.cover">
          <img
            style="width: 200px; height: 112px; vertical-align: middle"
            v-lazy="$global.imgUrl + formValidate.cover"
            alt=""
          />
          <div class="demo-upload-list-cover">
            <Icon
              type="ios-trash-outline"
              @click.native="formValidate.cover = ''"
            ></Icon>
          </div>
        </div>
        <Upload
          v-else
          ref="upload"
          type="drag"
          style="display: inline-block; width: 200px"
          :action="`${$global.uplodeUrl}zw-public/web/common/upload`"
          :headers="{ token: token }"
          :max-size="5120"
          accept=".png, .jpg, .jpeg"
          :format="['jpg', 'jpeg', 'png']"
          :show-upload-list="false"
          :on-success="handleSuccess"
          :on-format-error="handleFormatError"
          :on-exceeded-size="handleMaxSize"
        >
          <div style="width: 200px; height: 112px; line-height: 112px">
            <Icon type="ios-camera" size="20"></Icon>
          </div>
        </Upload>
        <p style="line-height: 114px; margin-left: 30px">
          建议比例16:9，支持jpg、jpeg、png格式，大小不超过5MB，最佳分辨率750*422（px）
        </p>
      </FormItem>
      <FormItem
        class="form-item"
        label="课程详情"
        prop="content"
        ref="FormItemContent"
      >
        <Editor
          :id="'editor'"
          v-model="formValidate.content"
          :placeholder="'请输入正文'"
        />
      </FormItem>
      <FormItem class="form-item" label="售卖方式" prop="saleType">
        <RadioGroup v-model="formValidate.saleType">
          <Radio :label="0">免费</Radio>
          <Radio :label="1">付费</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem
        v-if="hasPrice"
        class="form-item"
        label="售卖价格"
        prop="salePrice"
        :rules="[{ validator: validatePrice, trigger: 'change | blur' }]"
      >
        <Input v-model="formValidate.salePrice" placeholder="请输入售卖价格" />
      </FormItem>
      <FormItem class="form-item url_input" label="课程地址" prop="urlAddr">
        <Input
          v-model.trim="formValidate.urlAddr"
          placeholder="请输入课程地址"
        />
        <Button class="url_btn" type="primary" @click="urlModel = true"
          >获取课程地址</Button
        >
      </FormItem>
      <div class="submit-container">
        <Button @click="preview" :disabled="isShow" v-throttleClick="2000"
          >预览</Button
        >
        <Button
          @click="handleSubmit(formValidate, 1)"
          :disabled="canClick"
          v-throttleClick="2000"
          >保存</Button
        >
        <Button
          @click="handleSubmit(formValidate, 0)"
          :disabled="canClick"
          v-throttleClick="2000"
          >发布</Button
        >
      </div>
    </Form>
    <Modal v-model="urlModel" class="url_model">
      <p slot="header">获取课程/页面地址</p>
      <p style="text-align: center">
        获取课程/页面地址请联系平台工作人员 <br />
        联系方式：010-82616015
      </p>
      <div slot="footer"></div>
    </Modal>
    <AuthenticationModel
      v-if="isFlag"
      @handleClose="isFlag = false"
    ></AuthenticationModel>
  </div>
</template>
  
<script>
import { mapState } from "vuex";
import Editor from "../../components/editor";
import ruleUtils from "@/utils/ruleValidate.js";
import TitleSummaryEditor from "@/views/PCView/user/components/TitleSummaryEditor";
import AuthenticationModel from "../../components/AuthenticationModel.vue";
export default {
  components: {
    Editor,
    TitleSummaryEditor,
    AuthenticationModel,
  },
  data() {
    return {
      isShow: true, // 预览按钮是否可点击
      canClick: false,
      isFlag: false,
      urlModel: false,
      titleFocus: false,
      hasPrice: false,
      titleWordCount: 0,
      ismodify: 1, // 不通过修改标识
      formValidate: {
        auditStatus: 1, // this.ismodify === 2 已发布修改, status 1是保存 2是发布
        articleType: 9,
        title: "",
        cover: "",
        content: "",
        saleType: 0,
        salePrice: "",
        urlAddr: "",
      },
      ruleValidate: ruleUtils,
      previewData: {
        data: {
          articleId: this.$route.query.id ? this.$route.query.id : "",
          articleType: 9,
        },
      },
    };
  },
  computed: {
    ...mapState(["userInfo", "token"]),
  },
  watch: {
    "formValidate.title": {
      handler() {
        this.$refs.FormItemTitle.$emit("on-form-change"); // 对非View组件触发表单校验change方法
      },
      deep: true,
      // immediate: true,
    },
    "formValidate.saleType": {
      handler(newVla, oldVlia) {
        if (newVla == 0) {
          this.formValidate.salePrice = "";
        }
        this.hasPrice = newVla == 1;
      },
      deep: true,
      immediate: true,
    },
    "formValidate.content"() {
      this.$nextTick(() => {
        this.$refs.FormItemContent.$emit("on-form-change"); // 对非View组件触发表单校验change方法
      });
    },
  },
  created() {
    // 认证
    if (this.userInfo.user.customerType === 1) {
      this.isFlag = true;
    }
  },
  mounted() {
    this.titleFocus = true;
    if (this.$route.query.id) {
      this.getEcho(this.formValidate);
      this.isShow = false;
    }
  },
  methods: {
    // 图片上传成功
    handleSuccess(res) {
      this.formValidate.cover = res.content.url;
    },
    // 图片上传格式
    handleFormatError() {
      this.$Notice.warning({
        title: "上传文件格式错误",
        desc: "封面只能上传pdf,jpg类型文件",
      });
    },
    // 图片大小超出
    handleMaxSize() {
      this.$Notice.warning({
        title: "图片上传过大",
        desc: "封面图大小超过1M.",
      });
    },
    // 校验title
    validatetitle(rule, value, callback) {
      if (this.titleWordCount < 5 || this.titleWordCount > 50) {
        return callback(new Error("标题限制5到50个字数"));
      } else {
        callback(); // 必须有此项回调，否则验证会一直不通过
      }
    },
    validatePrice(rule, value, callback) {
      let str = value.toString()
      if (str === "") {
        return callback(new Error("请输入售卖价格"));
      } else if (isNaN(Number(str))) {
        return callback(new Error("售卖价格只能输入数字"));
      } else if (str.indexOf(".") !== -1) {
        let index = str.indexOf(".");
        let strOne = str.substring(0, index);
        let strTwo = str.substring(index + 1, str.length);
        if (strOne.length > 6) {
          return callback(new Error("售卖价格不能超过十万位"));
        } else if (strTwo.length > 2) {
          return callback(new Error("只能输入小数点后两位"));
        } else {
          callback(); // 必须有此项回调，否则验证会一直不通过
        }
      } else if (str.length > 6) {
        return callback(new Error("售卖价格不能超过十万位"));
      } else {
        callback(); // 必须有此项回调，否则验证会一直不通过
      }
    },
    // 获取title及计算字数
    getTitle(params) {
      /* params接收富文本对象，以JSON字符串方式传递，需解析为对象；
        解析后格式如{id: "englishTitle",value:{default: ""}} */
      params = JSON.parse(params);
      // params.value获取富文本输入框的值，有两种可能的值，默认为对象类型 value:{default: ""}；一旦有值，则变为字符串类型，如value: '<p style="line-height: 1.5;">&nbsp;'
      let originalText = params.value; // 获取富文本输入框原始值
      if (typeof originalText == "object") originalText = "";
      // 定义正则表达式reg 过滤标签（无法正常保留<>,如遇<某某决议>这种，还需修改正则）
      var reg = new RegExp("<[^<>]+>", "g");
      // 过滤后的字符串内容，用于统计字数
      let countText = originalText.replace(reg, "");
      // 现将特殊字符$nbsp;替换成空格然后将其他特殊字符匹配成1来便于计数
      var reg2 = /\&[0-9a-z]+;/g;
      countText = countText.replace(/&nbsp;/gi, "");
      if (countText.match(reg2) != null && countText.match(reg2).length != 0) {
        countText = countText.replace(reg2, "1");
      }
      // 将原值中的额$nbsp;替换为普通空格(html中的空格)
      originalText = originalText.replace(/&nbsp;/gi, "");
      // 不为空时，保留sub,sup标签，过滤其他标签
      originalText = originalText.replace(/(?!<(\/?sub|\/?sup).*?>)<.*?>/g, "");
      originalText = originalText.trim();
      // 去掉头尾空格以计数
      countText = countText.trim();
      this.formValidate.title = originalText;
      countText = this.filterSubSup(countText);
      this.titleWordCount = countText.length;
      this.$refs.FormItemTitle.$emit("on-form-change"); // 对非View组件触发表单校验change方法
    },
    // 过滤字符串中的sub/sup标签，返回过滤后的字符串。以计字数
    filterSubSup(s) {
      if (s.indexOf("<sub>") != -1 || s.indexOf("<sup>") != -1) {
        s = s.replace(/<sub>/gi, "");
        s = s.replace(/<\/sub>/gi, "");
        s = s.replace(/<sup>/gi, "");
        s = s.replace(/<\/sub>/gi, "");
      }
      return s;
    },
    // 预览
    async preview() {
      const resp = await this.$apis.userServe.setPreview(this.previewData.data);
      let URL = this.$router.resolve({
        path: "/previewCourse",
        query: {
          articleId: resp.data,
        },
      });
      window.open(URL.href, "_blank");
    },
    // 表单提交按钮
    handleSubmit(params, status) {
      this.canClick = true;
      // 认证
      if (this.userInfo.user.customerType === 1) {
        this.isFlag = true;
        return;
      }
      params.auditStatus = status === 1 ? 1 : this.ismodify === 2 ? 2 : 0; // this.ismodify === 2 已发布修改, status 1是保存 0是发布
      this.$refs.formValidate.validate(async (valid) => {
        if (valid) {
          const { data } = await this.$apis.userServe.webSave(params);
          if (data.resultCode === "200") {
            this.isShow = false;
            this.$Message.success(status === 1 ? "保存成功" : "发布成功");
            this.previewData = data;
            this.canClick = false;
            this.formValidate.articleId = data.data.articleId;
            if (status === 1) return;
            this.$router.push("/user/courseMan");
          } else {
            this.canClick = false;
            this.$Message.error(data.resultDesc);
          }
        } else {
          this.canClick = false;
          this.$Message.error("填写错误,请检查后重新提交");
        }
      });
    },
    // 回显
    async getEcho(f) {
      const resp = await this.$apis.userServe.getDetailsByUser({
        articleId: this.$route.query.id,
        articleType: 9,
      });
      this.ismodify = resp.data.data.auditStatus;
      for (const key in resp.data.data) {
        this.formValidate[key] = resp.data.data[key];
      }
      this.formValidate.articleType = 9;
      this.formValidate.articleId = this.formValidate.id;
    },
  },
};
</script>
  
<style lang="scss" scoped>
.url_model ::v-deep .ivu-modal-footer {
  border-top: none;
}
#text-container ::v-deep table {
  th,
  td {
    width: 200px;
    height: 35px;
    vertical-align: top;
    word-break: break-all;
  }
}
#text-container ::v-deep .placeholder {
  color: #999;
}
#text-container ::v-deep .w-e-text-container {
  z-index: 1 !important;
}
#toolbar-container ::v-deep .w-e-toolbar {
  justify-content: center;
  z-index: 2 !important;
}
#text-container {
  width: 100%;
  min-height: 300px;
  border: none;
  outline: none;
  padding: 4px 7px;
  color: #515a6e;
}
::v-deep .ivu-tree-title:hover {
  background-color: #fff;
}
::v-deep .ivu-tree-title-selected,
.ivu-tree-title-selected:hover {
  background-color: #fff;
}
::v-deep .ivu-tree-children li {
  display: flex;
  margin: 0;
}
::v-deep .ivu-tree-children li .ivu-tree-arrow {
  display: none;
}
::v-deep .ivu-tree-children li .ivu-tree-children li {
  margin: 30px 40px 0 -60px;
}
::v-deep .ivu-tree-children li .ivu-tree-title {
  width: 100px;
}
::v-deep .ivu-radio-group {
  white-space: nowrap;
}
.ivu-input-wrapper ::v-deep input {
  border: none;
  background-color: #fff;
  height: 38px;
}
.ivu-input-wrapper ::v-deep input::-webkit-input-placeholder,
.ivu-input-wrapper ::v-deep textarea::-webkit-input-placeholder {
  color: #999;
}
.ivu-input-wrapper ::v-deep textarea {
  border: none;
}

::v-deep .ivu-upload {
  height: auto;
}
.demo-upload-list {
  display: inline-block;
  width: 200px;
  height: 112px;
  text-align: center;
  line-height: 112px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  margin-right: 4px;
}
.demo-upload-list img {
  width: 100%;
  height: 100%;
}
.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}
.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
.fontColor {
  color: red !important;
}
.form-container {
  margin: 0 auto 100px;
  padding: 60px 100px 0;
  width: 1200px;
  background-color: #fff;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
  .form-item {
    padding-bottom: 25px;
    width: 100%;
    color: #999;
    &::v-deep .ivu-form-item-label {
      min-width: 80px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    &::v-deep .ivu-form-item-content {
      display: flex;
      // align-items: center;
    }
    &:not(:last-child) {
      border-bottom: 1px solid #dcdcdc;
    }
    .title {
      flex: 1;
      display: flex;
      align-items: flex-end;
      height: 100%;
      line-height: 38px;
      position: relative;
      .titleInput {
        flex: 1;
        margin-right: 10px;
      }
      &::v-deep .ivu-input-type-textarea {
        textarea {
          font-size: 36px;
          resize: none;
        }
      }
    }
    .abstract {
      ::v-deep .ivu-input-type-textarea {
        textarea {
          font-size: 14px;
          resize: none;
        }
      }
    }
    .left,
    .right {
      display: flex;
      justify-content: space-around;
      align-items: center;
      .plus {
        width: 30px;
        height: 30px;
        border: 1px solid #dcdcdc;
        border-radius: 50%;
        text-align: center;
        line-height: 30px;
        font-size: 2em;
      }
    }
    .left {
      border-right: 1px solid #dcdcdc;
      width: 355px;
    }
    .right {
      margin-left: 10px;
      width: 642px;
    }
    .year,
    .center,
    .stage {
      display: flex;
      align-items: center;
    }
    .year {
      width: 299px;
      border-right: 1px solid #dcdcdc;
    }
    .center {
      width: 323px;
      border-right: 1px solid #dcdcdc;
    }
    .stage {
      width: 374px;
    }
    label {
      white-space: nowrap;
      margin-right: 20px;
    }
  }
  .title-item {
    align-items: end;
  }
  .url_input {
    position: relative;
    &::v-deep input {
      padding-right: 125px;
    }
  }
  .url_btn {
    position: absolute;
    right: 3px;
    top: 3px;
  }
}
.submit-container {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 80px;
  height: 70px;
  background-color: #fff;
  text-align: center;
  line-height: 70px;
  button {
    margin: 0 10px;
  }
}
</style>
  